import React from "react";
import { Container, Row, Col } from "reactstrap";
import ProductsList from "../components/UI/ProductsList";
import products from "../assets/data/products";
import Helmet from "../components/Helmet/Helmet";

import "../styles/filter-item.css";

const Pasta = () => {
  const filteredProducts = products.filter((item) => item.category === "pasta");

  return (
    <Helmet title="Pasta">
      <section className="filtered__items">
        <Container>
          <Row>
            <Col lg="12">
              <h2 className="filtered__items-title text-center mt-5 mb-5">Pasta</h2>
            </Col>
            <ProductsList data={filteredProducts} />
          </Row>
        </Container>
      </section>
    </Helmet>
  );
};

export default Pasta;